import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { ClimbingBoxLoader } from 'react-spinners';

import './index.css'
import App from './App'
import { persistor, store } from './store'

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={
        <ClimbingBoxLoader className='loader' color={'#36D7B7'} loading={true} />
      } persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js